export const sampleProducts = [
  {
    ProductID: 324,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },
  {
    ProductID: 325,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 326,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 327,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 328,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 329,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 330,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 331,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 332,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 333,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 334,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 335,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 336,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 337,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 338,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 339,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 340,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 341,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },{
    ProductID: 342,
    HouseWayBill: "12121212",
    Carrier: "4324234",
    MasterWayBill: "80980980",
    FlightNo: "98798797",
    EATDateAtAirport: new Date(2021, 8, 20),
    Time: "17:00",
    DestLocationPort: "Banglore",
    TimeZone: "IST",
    EATDateAtXDock: new Date(2018, 2, 20),
    Time: "22:00",
    DestinationLocationRemarks: "Sample data"
  },
];
